import { stableStringifyObject } from "./stableStringifyObject.js";
const isEqualUser = (userA, userB) => stableStringifyObject(userA) === stableStringifyObject(userB);
export {
  isEqualUser
};
//# sourceMappingURL=isEqualUser.js.map